module.exports = __webpack_public_path__ + "static/media/typical2.bac1775d.png";